module.exports = __webpack_public_path__ + "img/logo.4783c6e9.jpg";